export default __webpack_public_path__ + "private/foundation/images/a5cf35f76af064a2f7c6b985f6a89d2d.svg";